import * as React from 'react';
import { translate } from 'react-i18next';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import * as c from 'models/constants';
import { LoadingOverlayWrapper, ItemCardList } from 'components';
import { IItemCardList } from 'models/itemcard';
require('./style.css');

interface IProps {
	products: any;
	isFetchingProducts: boolean;
	selectedTab: string;
	t?: (key: string, object?: any) => string;
	changeTabAndGetRequiredData?: (selectedTab: string) => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class DashboardProducts extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { t } = this.props;
		const { isFetchingProducts, products, selectedTab, changeTabAndGetRequiredData } = this.props;

		const listProps: IItemCardList = {
			items: products,
			itemType: c.NODE_TYPE_SHOPDASHBOARD_PRODUCT_ITEM_CARD,
		};

		return (
			<div className="shopDashboardProducts">
				<LoadingOverlayWrapper
					active={isFetchingProducts}
					spinner={true}
					text={t('BSPortal_Common_Loading')}
					background="rgba(0, 0, 0, 0.1)"
				>
					<Tabs
						name={c.SHOPDASHBOARD_PRODUCTTABS_NAMESPACE}
						tabComponent="div"
						className="profileTabs"
						handleSelect={(selectedTab) => {
							changeTabAndGetRequiredData(selectedTab);
						}}
						selectedTab={selectedTab}
					>
						<div className="tabLinks">
							<div className="tabLinksPositionMiddle">
								<TabLink key="mostsoldtablink" className="tabLink" to={c.SHOPDASHBOARD_TAB_MOSTSOLD}>
									{t('Shop_Dashboard_Products_MostSold')}
								</TabLink>
								<TabLink key="mostlikedtablink" className="tabLink" to={c.SHOPDASHBOARD_TAB_MOSTLIKED}>
									{t('Shop_Dashboard_Products_MostLiked')}
								</TabLink>
								<TabLink key="mostwishlistedtablink" className="tabLink" to={c.SHOPDASHBOARD_TAB_MOSTWISHLISTED}>
									{t('Shop_Dashboard_Products_MostWishlisted')}
								</TabLink>
							</div>
						</div>
						<div className="tabsWrapper">
							<TabContent key="mostsoldtabcontent" for={c.SHOPDASHBOARD_TAB_MOSTSOLD}>
								<ItemCardList {...listProps} />
							</TabContent>
							<TabContent key="mostlikedtabcontent" for={c.SHOPDASHBOARD_TAB_MOSTLIKED}>
								<ItemCardList {...listProps} />
							</TabContent>
							<TabContent key="mostwishlistedtabcontent" for={c.SHOPDASHBOARD_TAB_MOSTWISHLISTED}>
								<ItemCardList {...listProps} />
							</TabContent>
						</div>
					</Tabs>
				</LoadingOverlayWrapper>
			</div>
		);
	}
}

export { DashboardProducts };
